import { useMemo } from 'react'
import { ROLE_SYS, useRoleContext } from '../role.context'
import { useAuthContext } from '../../context/auth.context'

const fullAccess = { accessCreate: true, accessRead: true, accessUpdate: true, accessDelete: true }
const noAccess = { accessCreate: false, accessRead: false, accessUpdate: false, accessDelete: false }

export const useRoleSys = type => {
  const authContext = useAuthContext()
  const roleContext = useRoleContext()

  return useMemo(
    () => {
      if (authContext.state.isSysRoot) {
        return fullAccess
      }

      return roleContext.sysRoles[type] || noAccess
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [authContext.state, roleContext.sysRoles]
  )
}

export const useRoleSysDashboard = () => useRoleSys(ROLE_SYS.SYS_DASHBOARD)
export const useRoleSysApp = () => useRoleSys(ROLE_SYS.SYS_APP)
export const useRoleSysOrganization = () => useRoleSys(ROLE_SYS.SYS_ORGANIZATION)
export const useRoleSysLogin = () => useRoleSys(ROLE_SYS.SYS_LOGIN)
export const useRoleSysAuthStatus = () => useRoleSys(ROLE_SYS.SYS_AUTH_STATUS)
export const useRoleSysProvider = () => useRoleSys(ROLE_SYS.SYS_PROVIDER)
export const useRoleSysSendgridEvent = () => useRoleSys(ROLE_SYS.SYS_SENDGRID_EVENT)
export const useRoleSysRequestLog = () => useRoleSys(ROLE_SYS.SYS_REQUEST_LOG)
export const useRoleSysErrors = () => useRoleSys(ROLE_SYS.SYS_ERRORS)
export const useRoleSysAlertRouting = () => useRoleSys(ROLE_SYS.SYS_ALERT_ROUTING)
export const useRoleSysLmsPreset = () => useRoleSys(ROLE_SYS.SYS_LMS_PRESET)
export const useRoleSysApiKey = () => useRoleSys(ROLE_SYS.SYS_API_KEY)
export const useRoleSysNotify = () => useRoleSys(ROLE_SYS.SYS_NOTIFY)
export const useRoleSysAiToolsTelemetry = () => useRoleSys(ROLE_SYS.SYS_AI_TOOLS_TELEMETRY)
export const useRoleSysPackages = () => useRoleSys(ROLE_SYS.SYS_PACKAGES)
export const useRoleSysBilling = () => useRoleSys(ROLE_SYS.SYS_BILLING)
export const useRoleSysConsentLog = () => useRoleSys(ROLE_SYS.SYS_CONSENT_LOG)
